import { useMutation } from 'react-query';

import { getCardDates as mutationFn } from 'api/endPoints/getCardDates';

export const useMutationGetCurrentActualDates = () => {
    return useMutation<IGetCurrentActualDatesResponse, QueryError, IGetCurrentActualDatesPayload>((params) =>
        mutationFn(params),
    );
};

interface IGetCurrentActualDatesPayload {
    id: number;
    laneId: string;
    isVirtual: boolean;
    versionId: number;
}

interface IGetCurrentActualDatesResponse {
    endDate: number;
    id: number;
    startDate: number;
}
